const scoreTypes = {
  GET_SCORE_LIST_REQUEST: "GET_SCORE_LIST_REQUEST",
  GET_SCORE_LIST_SUCCESS: "GET_SCORE_LIST_SUCCESS",
  GET_SCORE_LIST_FAILED: "GET_SCORE_LIST_FAILED",
  RESET_SCORE_LIST: "RESET_SCORE_LIST",
}

export { scoreTypes };